// 🔧 vendor_report.js
// ✅ Purpose: Builds standardized execution reports for the Vendor Engine
// ✅ Features:
// - Reports vendors created
// - Returns Demo Report v2-compatible structured results
// - Keeps Vendor Engine reporting consistent with other LGV engines
// - Fully block-commented for clarity and future devs

export const buildVendorReport = ({
  vendorResults,
} = {}) => {
  const vendors =
    vendorResults?.vendors || [];

  return {
    success: true,

    created: {
      vendors: vendors.length,
    },

    summary: [
      `${vendors.length} Vendors`,
    ].join(" • "),
  };
};